import { React, PT } from '@gasbuddy/react';
import { Input, Label, Checkbox, Grid } from 'semantic-ui-react';

export const BrandEditDetails = ({ brand, editHandler }) => (
  <Grid columns={10} centered="true">
    <Grid.Row>
      <Grid.Column width={5} padded="horizontally">
        <Checkbox defaultChecked={brand.is_cstore === true} defaultIndeterminate={brand.is_cstore === undefined} label="C-store Brand" onChange={editHandler('is_cstore', 'bool')} />
      </Grid.Column>
      <Grid.Column width={5} padded="horizontally">
        <Checkbox defaultChecked={brand.is_fuel === true} defaultIndeterminate={brand.is_fuel === undefined} label="Fuel Brand" onChange={editHandler('is_fuel', 'bool')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={5} padded="horizontally">
        <Checkbox defaultChecked={brand.allow_brand_sharing === false} defaultIndeterminate={brand.allow_brand_sharing === undefined} label="Owner / Operated" type="checkbox" onChange={editHandler('allow_brand_sharing', 'bool')} />
      </Grid.Column>
      <Grid.Column width={5} padded="horizontally">
        <Checkbox defaultChecked={brand.display === true} defaultIndeterminate={brand.display === undefined} label="Display" type="checkbox" onChange={editHandler('display', 'bool')} />
      </Grid.Column>
      <Grid.Column width={5} padded="horizontally">
        <Checkbox defaultChecked={brand.pwgb_not_accepted === true} defaultIndeterminate={brand.pwgb_not_accepted === undefined} label="PWGB Not Accepted" type="checkbox" onChange={editHandler('pwgb_not_accepted', 'bool')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Label htmlFor="description">Description</Label>
      <Input id="description" defaultValue={brand.description} placeholder={brand.description ? '' : 'Enter a description...'} onChange={editHandler('description', 'string')} />
    </Grid.Row>
  </Grid>
);

BrandEditDetails.defaultProps = {
  brand: {
    description: '',
    is_cstore: null,
    is_fuel: null,
    allow_brand_sharing: null,
    display: null,
    pwgb_not_accepted: null,
  },
  editHandler: () => () => {},
};

BrandEditDetails.propTypes = {
  brand: PT.shape(
    {
      description: PT.string,
      is_cstore: PT.boolean,
      is_fuel: PT.boolean,
      allow_brand_sharing: PT.boolean,
      display: PT.boolean,
      pwgb_not_accepted: PT.boolean,
    },
  ),
  editHandler: PT.func,
};
